import React, { useCallback } from "react";

import { Grid, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

import useStyles from "./Search.styles";
import {
  getSearchedGamesStart,
  resetSearchGames
} from "../../../../../../redux-saga/redux/casino/lobby/casinoGames";

const SearchField = ({
  searchInput,
  offset,
  setSearch,
  makeProviderCategoryFilter
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t } = useTranslation();

  const handleChangeSearch = useCallback(
    (event) => {
      offset.current = 1;
      setSearch(event.target.value);
      const searchValue = event.target.value.trim();
      if (searchValue === searchInput.trim()) {
        return;
      }
      const providerCategoryFilter = makeProviderCategoryFilter();
      if (
        !providerCategoryFilter.providerId &&
        !providerCategoryFilter.subCategoryId &&
        !searchValue
      ) {
        dispatch(resetSearchGames());
        return;
      }
      dispatch(
        getSearchedGamesStart({
          isMobile,
          page: 1,
          limit: 12,
          search: searchValue || null,
          ...providerCategoryFilter
        })
      );
    },
    [dispatch, makeProviderCategoryFilter, offset, setSearch, searchInput]
  );

  return (
    <Grid className={classes.headerSearch}>
      <TextField
        variant="outlined"
        placeholder={t("LOBBY.SEARCH_ALL_GAMES")}
        onChange={handleChangeSearch}
        value={searchInput}
      />
      <img src="/images/search-icon.svg" alt="Search" />
    </Grid>
  );
};

export default SearchField;
